import {} from "@mui/material";
import "./App.css";
import NationBuilderSignInPage from "./Dashboard/Pages/NationBuilderSignInPage";
import DashboardPage from "./Dashboard/Pages/DashboardPage";
import { Navigate, Route, Routes, Outlet } from "react-router-dom";
import SignInPage from "./Dashboard/Pages/SignInPage";
import { useAuth } from "./common/contexts/AuthProvider";
import { useNationBuilderToken } from "./common/contexts/NationBuilderTokenProvider";
import { NationBuilderAccessTokenStatus } from "./common/models/schema/NationBuilderAccessTokenStatus";
import Update360Page from "./Dashboard/Pages/Update360Page";
import UploadToCirclePage from "./Dashboard/Pages/UploadToCirclePage";
import UsersManagerPage from "./Dashboard/Pages/UsersManagerPage";
import { UserPermissionGroup } from "./common/models/schema/UserPermissionGroup";
import TagsManagerPage from "./Dashboard/Pages/TagsManagerPage";
import ResearchPersonDetailsPage from "./Dashboard/Pages/ResearchPersonDetails";
import CirclePersonDetailsPage from "./Dashboard/Pages/CirclePersonDetails";
import ProfileVersionsPage from "./Dashboard/Pages/ProfileVersionsPage";
import AdminInvitationsPage from "./Dashboard/Pages/AdminInvitationsPage";

const ProtectedRoute = ({
  condition,
  navigateTo,
}: {
  condition: boolean;
  navigateTo: string;
}) => {
  if (!condition) {
    return <Navigate to={navigateTo} replace />;
  }
  return <Outlet />;
};

function App() {
  const { isAuthenticated, userPermissions } = useAuth();
  const { tokenState } = useNationBuilderToken();
  return (
    <Routes>
      <Route index path="/" element={<SignInPage />} />
      <Route
        element={<ProtectedRoute condition={isAuthenticated} navigateTo="/" />}
      >
        <Route
          path="/nationbuilder-signin"
          element={<NationBuilderSignInPage />}
        />
        <Route
          element={
            <ProtectedRoute
              condition={tokenState === NationBuilderAccessTokenStatus.Valid}
              navigateTo="/nationbuilder-signin"
            />
          }
        >
          <Route path="/dashboard" element={<DashboardPage />}>
            <Route index element={<Navigate to="360Update" replace />} />
            <Route path="360Update" element={<Update360Page />} />
            <Route
              path="ResearchPersonDetails/:personId"
              element={<ResearchPersonDetailsPage />}
            />
            <Route path="UploadToCircle" element={<UploadToCirclePage />} />
            <Route
              path="CirclePersonDetails/:personId"
              element={<CirclePersonDetailsPage />}
            />
            <Route path="ProfileVersions" element={<ProfileVersionsPage />} />
            <Route
              element={
                <ProtectedRoute
                  condition={userPermissions === UserPermissionGroup.Admin}
                  navigateTo="/nationbuilder-signin"
                />
              }
            >
              <Route path="UsersManager" element={<UsersManagerPage />} />
              <Route path="TagsManager" element={<TagsManagerPage />} />
              <Route
                path="AdminInvitations"
                element={<AdminInvitationsPage />}
              />
            </Route>
          </Route>
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
